<div
  *ngIf="!isSettingUpAutopay"
  class="line-break"
  [class.border-top]="isDesktop"
></div>

<cdk-virtual-scroll-viewport
  *ngIf="bankAccounts.length > 0"
  data-cy="bank-account-scroll"
  class="cdk-scroll"
  orientation="vertical"
  itemSize="20"
>
  <div
    *cdkVirtualFor="
      let bankAccount of bankAccounts;
      let i = index;
      trackBy: trackItem
    "
    (click)="selectBankAccount(bankAccount)"
  >
    <ion-item data-cy="bank-account-list-item">
      <ion-label id="bank-account" data-cy="bank-name" data-private>
        <p class="bank-account-label">
          <span data-cy="bank-name">{{ bankAccount.bankName }}</span>
          &nbsp;(*****<span data-cy="bank-number">{{
            bankAccount.last4AccountNumber
          }}</span
          >)
        </p>
        <p class="bank-account-nickname" data-cy="bank-nick-name">
          {{ bankAccount.nickName }}
        </p>
      </ion-label>
      <ion-checkbox
        aria-labelledby="bank-account"
        slot="end"
        [checked]="bankAccount.bankID === bankIdSelected"
      ></ion-checkbox>
    </ion-item>
  </div>
</cdk-virtual-scroll-viewport>
<h6 *ngIf="bankAccounts.length === 0" data-cy="no-bank-accounts">
  {{ 'i18n.payments.addBankAccountModal.noBankAccounts' | translate }}
</h6>
